import { ColumnDataType } from '../types'
import { EnrichComponentDatabricks } from './common/enrichcomponent_db'

class EnrichPolygonsDatabricks extends EnrichComponentDatabricks {
  constructor() {
    super(
      {
        name: 'native.enrichpolygons',
        group: 'Data Enrichment',
        title: 'Enrich Polygons',
        description: `
      This uses a data source to enrich another target table with polygons.
      `,
        starred: true
      },
      'polygon',
      [ColumnDataType.Geography, ColumnDataType.Geometry],
      (x) => `${x}`,
      true
    )
  }
}

export { EnrichPolygonsDatabricks }
